import { inject, Injectable } from '@angular/core';
import { accountexternal } from 'src/shared/services/client/client';
import { ClientService } from 'src/shared/services/client/client.service';

@Injectable({ providedIn: 'root' })
export class EntitlementsDataService {
  private client = inject(ClientService);

  getPackageByCode(code: string) {
    return this.client.requestWithClient((client) => client.accountexternal.GetPackageByCode(code));
  }

  getUserEntitlements() {
    return this.client.requestWithClient((client) => client.accountexternal.GetUserEntitlements('me'));
  }

  applyMembership(user_doc_id: string, params: accountexternal.ApplyMembershipRequest) {
    return this.client.requestWithClient((client) => client.accountexternal.ApplyMembership(user_doc_id, params));
  }
}
